import { render, staticRenderFns } from "./reportSalesForecast.vue?vue&type=template&id=fe65452a&scoped=true&"
import script from "./reportSalesForecast.vue?vue&type=script&lang=js&"
export * from "./reportSalesForecast.vue?vue&type=script&lang=js&"
import style0 from "./reportSalesForecast.vue?vue&type=style&index=0&id=fe65452a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe65452a",
  null
  
)

export default component.exports